/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import type {
	useAddCommentPermissionCheckPermissionCheckAddCommentQuery as useAddCommentPermissionCheckPermissionCheckAddCommentQuery$data,
	useAddCommentPermissionCheckPermissionCheckAddCommentQueryVariables as useAddCommentPermissionCheckPermissionCheckAddCommentQuery$variables,
} from './__types__/useAddCommentPermissionCheckPermissionCheckAddCommentQuery';

const useAddCommentPermissionCheckPermissionCheckAddCommentQuery = graphql`
	query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId: ID!) {
		content(id: $contentId, status: ["draft", "current"]) {
			nodes {
				id
				type
				operations {
					operation
					targetType
				}
			}
		}
	}
`;

export const useAddCommentPermissionCheck = (contentId: string, cacheOnly = false) => {
	const { data, loading, error, refetch, networkStatus } = useQuery<
		useAddCommentPermissionCheckPermissionCheckAddCommentQuery$data,
		useAddCommentPermissionCheckPermissionCheckAddCommentQuery$variables
	>(useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
		variables: {
			contentId,
		},
		notifyOnNetworkStatusChange: true,
		fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
		skip: !contentId,
	});
	const contentNode = data?.content?.nodes?.[0];
	const operations = contentNode?.operations ?? [];

	const createPermission = operations.some(
		(operationResults) =>
			operationResults?.operation === 'create' && operationResults?.targetType === 'comment',
	);

	return {
		canAddComments: createPermission,
		loading,
		contentQueryError: error,
		refetch,
		networkStatus,
	};
};
